
const settings = {
  facebookAppId: '',
  globalDelay: 500,
  isMobile: window.innerWidth <= 769,

  gaId: 'UA-18261922-40'
};

export { settings };
